module.exports = __webpack_public_path__ + "img/plastics-title-bg.7b990fd3.png";